module.exports = __webpack_public_path__ + "static/melanydierks-ArtistStatement-6a8285d6f7e2e9fcd80904789cc2d8e7.pdf";